import type { AccountType } from '@witmetrics/utils';
import { ACCOUNT_TYPES } from '@witmetrics/utils/constants';
import { getLabLogoUrl, getPracticeLogoUrl } from '@/api/urls';

export const classes = {
  header:
    'relative z-20 mx-6 mb-1 mt-4 flex h-14 items-center gap-3 rounded-2xl pl-5 pr-1.5 bg-[linear-gradient(110deg,hsla(26.7,74%,96.7%,.68),hsla(216,66%,98%,.36)_26%,hsla(280,34%,98%,.82)_78%,hsla(210,45%,97.5%,.86))] shadow-[0px_2px_12px_hsla(215,22%,64%,.3)] dark:bg-[linear-gradient(110deg,hsla(26.7,60%,40%,.3),hsla(216,50%,46%,.12)_26%,hsla(280,32%,44%,.26)_78%,hsla(210,40%,44%,.28))] dark:shadow-[0px_3px_12px_rgba(0,0,0,.4)]',
  search:
    'ml-2 flex w-64 items-center gap-2 rounded-xl bg-[hsla(220,26%,87%,0.45)] px-3 py-1.5 text-sm text-grey-7 dark:bg-white/[0.08] dark:text-mauve-2',
  searchIcon: 'size-4',
  spacer: 'flex-1',
  divider: 'mx-0.5 h-6 w-px bg-black/10 dark:bg-white/10',
  iconButton:
    'place-center size-9 rounded-xl text-taupe-2 transition-colors hover:bg-black/5 dark:text-mauve-2 dark:hover:bg-white/5',
  addButtonWrapper: 'ml-2',
  addButton:
    'place-center size-9 rounded-xl bg-orange-2/[0.15] text-orange-2 transition-colors hover:bg-orange-2/25 dark:bg-orange-2/20 dark:text-orange-2 dark:hover:bg-orange-2/30',
  testingWrapper: 'text-orange-2 border border-orange-1 py-1 px-4 rounded-md',
  testingLink: 'ml-2 underline cursor-pointer font-medium',
};

export function getActiveLogoUrl(
  accountType: AccountType | undefined,
  logo: string | undefined
): string | null {
  if (!logo) return null;
  if (accountType === ACCOUNT_TYPES.PRACTICE) return getPracticeLogoUrl(logo);
  if (accountType === ACCOUNT_TYPES.LAB) return getLabLogoUrl(logo);
  return null;
}
